import { Modal } from 'antd';
import { useState } from 'react';
import { GET } from 'services/sendRequestAPI';

const useGetEPLine = () => {
    const [dataSource, setDataSource] = useState(null);
    const [loading, setLoading] = useState(false);
    const onGetEPLine = async (docNo) => {
        try {
            setLoading(true);
            const res = await GET('/sale/get-ep-line', { docNo: docNo });
            if (res?.status !== 200) return;
            setDataSource(res?.data?.result?.data?.map((item, index) => ({
                ...item,
                key: index
            })));
        } catch (error) {
            Modal.error({
                title: 'เกิดข้อผิดพลาด',
                content: error?.message || 'เกิดข้อผิดพลาดในการดึงข้อมูล'
            });
        } finally {
            setLoading(false);
        }
    }
    return {
        onGetEPLine,
        dataSource,
        loading
    }
}

export default useGetEPLine